import { useDocumentTitle } from '@hooks/index';
import React, { FC, useEffect } from 'react';
import { FOIRequestForm } from '@ui/components/organisms/FOIRequestForm';
import { useTranslate } from '@translations/useTranslate';
import { VisitRequestStatus } from '@ui/components/organisms/VisitRequestStatus';
import { Translations } from '@translations/translationsTypes';
import { RouteComponentProps, useHistory } from 'react-router-dom';

interface FOIRequestParams {
  languageId: string;
}
interface FOIRequestProps extends RouteComponentProps<FOIRequestParams> {
  param: string;
}
export const FOIRequest: FC<FOIRequestProps> = (props) => {
  const { t, setLanguage } = useTranslate();
  useDocumentTitle(t('page.title.foi'));
  const history = useHistory();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [requestId, setRequestId] = React.useState('');
  const [jiraTicket, setJiraTicket] = React.useState('');
  const changeCurrentPage = React.useCallback((page) => {
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    if (props?.match?.params?.languageId) {
      const language =
        props?.match?.params?.languageId === Translations.ar ? Translations.ar : Translations.en;
      setLanguage(language);
      history.replace('/foi-request');
    }
  }, [history, props?.match?.params?.languageId, setLanguage]);
  return (
    <>
      <h2 className="w-100 text-center fw-bold pt-2 pb-3">{t('foi.request.header')}</h2>
      {currentPage === 1 && (
        <FOIRequestForm
          onRequestSuccess={(jiraTicketId, freedomRequestId) => {
            setRequestId(freedomRequestId);
            setJiraTicket(jiraTicketId);
            changeCurrentPage(2);
          }}
          onRequestFailed={() => {
            changeCurrentPage(3);
          }}
        />
      )}
      {currentPage === 2 && <VisitRequestStatus requestNumber={requestId} isSuccess={true} />}
      {currentPage === 3 && <VisitRequestStatus requestNumber={requestId} isSuccess={false} />}
    </>
  );
};
